import React from "react";
import { useParams, Link } from "react-router-dom";

const PoolCarePurchaseSuccess = () => {
  const { listingId } = useParams();

  return (
    <div style={{ textAlign: "center", marginTop: 120, padding: "0 20px" }}>
      <h1 style={{ color: "#0b6b2d" }}>✅  Pool Care Purchase Successful</h1>

      <p>
  Your payment has been confirmed for Pool Care listing{" "}
  <strong>{listingId}</strong>.
</p>

<p>
  We’re finalising the sale details. You’ll see this in your dashboard shortly.
</p>

<p style={{ color: "#555", marginTop: 10 }}>
  Your total payment includes a <strong>15% buyer service fee</strong>.
  A full payment breakdown has been sent to your email.
</p>

<p style={{ color: "#555", marginTop: 10 }}>
  The seller’s contact details and instructions for the client handover will be
  sent to you by email.
</p>


      <div style={{ marginTop: 30 }}>
        <Link
          to="/dashboard"
          style={{
            padding: "12px 22px",
            background: "#0b6b2d",
            color: "white",
            textDecoration: "none",
            borderRadius: "6px",
            marginRight: "12px",
          }}
        >
          Go to Dashboard
        </Link>

        <Link
         to={`/poolcare/listing/${listingId}`}
          style={{
            padding: "12px 22px",
            background: "#333",
            color: "white",
            textDecoration: "none",
            borderRadius: "6px",
          }}
        >
          View Listing
        </Link>
      </div>
    </div>
  );
};

export default PoolCarePurchaseSuccess;
